export const calculateAges = (date: string) => {
  const today = new Date();
  const birthDate = new Date(date);
  if (birthDate > today) {
    return 0;
  }

  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
};
